import { getSupplierNameCorePart } from '../../ultils';

interface IProp {
    data: any;
}

export const Supplier: React.FC<IProp>  = ({ data }) => {
  const dataSupplierName = data.productVariations
    ? getSupplierNameCorePart(data.productVariations)
    : data.vendor?.value;

  return(   
    dataSupplierName
  );
};
